export interface MindOrderInstallationAddress {
  zipcode: string;
  number: string;
  district?: string;
  complement?: string;
}

export interface MindOrderRegistrationFee {
  value: number;
  inAdvance: boolean;
  payments: number;
}

export interface MindOrderDealPeriod {
  price: number;
  validity: number;
}

export interface MindOrderDeal {
  description: string;
  periods: MindOrderDealPeriod[];
}

export interface MindOrderProduct {
  id: number;
  type: string;
  name: string;
  price: number;
  hasContract?: boolean;
  registrationFee?: MindOrderRegistrationFee;
  extras?: unknown[];
  deal?: MindOrderDeal;
  tags?: string[];
}

export interface MindOrderMarketingDelivery {
  sms: boolean;
  call: boolean;
  voice: boolean;
  email: boolean;
}

export interface MindOrderCustomer {
  contactName: string;
  document: string;
  companyName: string;
  email: string;
  cpf: string;
  marketingDelivery: MindOrderMarketingDelivery;
}

export interface MindOrderSchedule {
  cold: boolean;
  period: number;
  label: string;
  date: string;
  dateStart: string;
  dateEnd: string;
}

export interface MindOrderInstallationSchedule {
  date: string;
  period: number;
}

export interface MindOrderCreateRequest {
  userUuid: string;
  regionId: string;
  homePass: string;
  catalog: string;
  salesChannel: string;
  mediaChannel: string;
  sellerCode: string | null;
  affiliateId?: string;
  installationFee: number;
  electronicInvoicing: boolean;
  paymentDay: number;
  installationAddress: MindOrderInstallationAddress;
  products: MindOrderProduct[];
  schedule: MindOrderSchedule[];
  customer: MindOrderCustomer;
}

export interface MindOrderCreateResponse {
  orderId: number;
  orderUuid: string;
  mindOrderId: number;
  status: string;
  userUuid: string;
  products: MindOrderProduct[];
  userDocument: string;
  sellerCode?: string;
  createdAt: string;
  installationAddress: MindOrderInstallationAddress;
  installationSchedule: MindOrderInstallationSchedule;
}

export interface MindOrderChannelEvent {
  orderUuid: string;
  total: number;
  paymentMethod: string;
  sellerCode?: string;
  products: MindOrderProduct[];
  status: string;
}

/** Minimal product shape for POST …/schedules/pme/cnpj (price in reais). */
export interface MindScheduleProduct {
  id: number;
  type: string;
  name: string;
  price: number;
}

export const MIND_ORDER_DEFAULTS = {
  catalog: 'net-empresas',
  salesChannel: 'externo',
  mediaChannel: 'desktop',
  paymentDay: 10,
  electronicInvoicing: true,
  registrationFee: {
    value: 0,
    inAdvance: false,
    payments: 0,
  } as MindOrderRegistrationFee,
  marketingDelivery: {
    sms: true,
    call: true,
    voice: true,
    email: true,
  } as MindOrderMarketingDelivery,
} as const;
